import React from 'react';
import Modal from '@/components/common/Modal';
import { LinkButton, SubmitButton } from '@/components/ui/Buttons';
import Icon from '@/components/ui/Icon';
import Text from '@/components/ui/Text';
import I18n from 'i18n-js';

interface AssignmentsBasedDeleteModalProps {
  assignmentLabel: string,
  closeModal: () => void,
  onDelete: () => void,
  isOpen: boolean,
  submitting: boolean,
}

const AssignmentsBasedDeleteModal = ({
  assignmentLabel,
  closeModal,
  isOpen,
  onDelete,
  submitting,
}: AssignmentsBasedDeleteModalProps) => {
  const modalBodyText = (
    <span dangerouslySetInnerHTML={{ __html: I18n.t('delete_assignment_warning_html') }} />
  );

  return (
    <Modal
      closeModal={closeModal}
      headerText={I18n.t('delete_assignment')}
      isOpen={isOpen}
    >
      <div className="tw-p-4 tw-bg-orange tw-bg-opacity-10 tw-border-orange tw-border tw-border-solid tw-rounded
      tw-flex tw-items-center tw-mb-8"
      >
        <Icon color="orange" icon="Warning" size={24} />
        <Text className="tw-flex-1 tw-ml-6" size="sm">
          {modalBodyText}
        </Text>
      </div>
      <Text className="tw-mb-2" size="sm" weight="bold">
        {I18n.t('delete_assignment_confirmation')}
      </Text>

      <p>{assignmentLabel}</p>

      <hr />

      <footer>
        <LinkButton
          onClick={closeModal}
        >
          {I18n.t('cancel')}
        </LinkButton>

        <SubmitButton
          color="red"
          disabled={submitting}
          submittingText={I18n.t('deleting')}
          onClick={onDelete}
        >
          {I18n.t('delete')}
        </SubmitButton>
      </footer>
    </Modal>
  );
};

export default AssignmentsBasedDeleteModal;
